import { ImportButton } from 'react-admin-import-csv';

// Fields edited in the backoffice with a RichTextInput (Tiptap), which always
// persists real HTML (<p>, <br>, ...). CSV cells are plain text with literal
// \n / \r\n line breaks, which HTML silently collapses as insignificant
// whitespace. Convert plain-text line breaks to <br> so imported rows render
// the same way as rows saved by hand.
const RICH_TEXT_FIELDS = ['details', 'cv', 'body'];

const hasHtmlTags = (value: string): boolean => /<[a-z][\s\S]*>/i.test(value);

const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const plainTextToHtml = (value: string): string => escapeHtml(value).split(/\r\n|\r|\n/).join('<br>');

// https://github.com/benwinding/react-admin-import-csv
const config = {
  // Enable logging
  // logging: true,
  // Disable the attempt to use "createMany", will instead just use "create" calls
  // disableCreateMany?: boolean,
  // Disable the attempt to use "updateMany", will instead just use "update" calls
  // disableUpdateMany?: boolean,

  // Disable the attempt to use "getMany", will instead just use "getSingle" calls
  disableGetMany: true,

  // Disable "import new" button
  // disableImportNew?: boolean;
  // Disable "import overwrite" button
  // disableImportOverwrite?: boolean;
  // A function to translate the CSV rows on import
  // preCommitCallback?: (action: "create" | "overwrite", values: any[]) => Promise<any[]>;
  // A function to handle row errors after import
  // postCommitCallback?: (error: any) => void;

  // Transform rows before anything is sent to dataprovider
  // CSV uses ';' to
  transformRows: async (csvRows: any[]): Promise<any[]> => {
    // console.log('+_+_+_+_ ', { csvRows });
    const res = csvRows.map((row: any) => {
      // console.log('+_+_+_+_ BEFORE ', { row, tid: row['tagsId'], btid: !!row['tagsId'] });

      // an empty 'tagsId' (or locations/paths/speakersId) is saved as ',,' in the CSV. Then row['tagsId'] === ''
      // But that is different from a table that has no 'tagsId' field (hence row['tagsId]===undefined).
      // So we need to convert "row['tagsId'] === ''" to "[]" (not to '');
      const locationsId =
        row['locationsId'] === undefined ? false : row['locationsId'] === '' ? [] : (row['locationsId'] as string).split(';');
      const pathsId = row['pathsId'] === undefined ? false : row['pathsId'] === '' ? [] : (row['pathsId'] as string).split(';');
      const speakersId = row['speakersId'] === undefined ? false : row['speakersId'] === '' ? [] : (row['speakersId'] as string).split(';');
      const tagsId = row['tagsId'] === undefined ? false : row['tagsId'] === '' ? [] : (row['tagsId'] as string).split(';');

      const isSponsored =
        row['isSponsored'] === undefined ? undefined : row['isSponsored'].toLowerCase() === 'false' ? false : !!row['isSponsored'];
      const isRockStar =
        row['isRockStar'] === undefined ? undefined : row['isRockStar'].toLowerCase() === 'false' ? false : !!row['isRockStar'];
      const richTextUpdates: Record<string, string> = {};
      RICH_TEXT_FIELDS.forEach((field) => {
        const value = row[field];
        if (typeof value === 'string' && value !== '' && !hasHtmlTags(value)) {
          richTextUpdates[field] = plainTextToHtml(value);
        }
      });

      const after = {
        ...row,
        ...(locationsId && { locationsId }),
        ...(pathsId && { pathsId }),
        ...(speakersId && { speakersId }),
        ...(tagsId && { tagsId }),
        ...(row['isSponsored'] !== undefined && { isSponsored }),
        ...(row['isRockStar'] !== undefined && { isRockStar }),
        ...richTextUpdates,
      };
      // console.log('+_+_+_+_ AFTER ', { after, tid: row['tagsId'] });
      return after;
    });
    return res;
  },

  // Async function to Validate a row, reject the promise if it's not valid
  // validateRow?: (csvRowItem: any) => Promise<void>;
  // Any option from the "papaparse" library
  // parseConfig: {
  //   dynamicTyping: true,
  // For all options see: https://www.papaparse.com/docs#config
  // },
};

export const ImportButtonCSV = (props: any) => {
  return <ImportButton {...props} {...config} />;
};
